import React, { Component } from 'react';

class FamilyBreadcrumb extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Family Menu
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Families
                                    </li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Families</h2>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FamilyBreadcrumb;
